import { useState } from "react";
import "../styles/DashboardToggleStyles.css";
// const DashboardToggleComponent = ({
//   options,
//   onChange,

// }: {
//   options: string[];
//   onChange: (val: string) => void;
// }) => {
//   const [active, setActive] = useState(options[0] || "");

//   const handleToggle = (val: string) => {
//     setActive(val);
//     onChange(val);
//   };

//   return (
//     <div className="dashboard-toggle">
//       {options.map((opt) => (
//         <button
//           key={opt}
//           className={`toggle-btn ${opt === active ? "active" : ""} ${
//             opt === options[0] && active === opt ? "left-active" : ""
//           } ${opt === options[options.length - 1] && active === opt ? "right-active" : ""}`}
//           onClick={() => handleToggle(opt)}
//         >
//           {opt}
//         </button>
//       ))}
//     </div>
//   );
// };
// export default DashboardToggleComponent;

// DashboardToggleComponent.tsx
const DashboardToggleComponent = ({
  options,
  onChange,
  value, // Add this prop
}: {
  options: string[];
  onChange: (val: string) => void;
  value?: string; // Accept external value
}) => {
  // Remove local state, use prop
  // const [active, setActive] = useState(options[0] || "");

  const handleToggle = (val: string) => {
    // setActive(val); // Remove this
    onChange(val);
  };

  return (
    <div className="dashboard-toggle">
      {options.map((opt) => (
        <button
          key={opt}
          className={`toggle-btn ${opt === value ? "active" : ""} ${
            opt === options[0] && value === opt ? "left-active" : ""
          } ${
            opt === options[options.length - 1] && value === opt
              ? "right-active"
              : ""
          }`}
          onClick={() => handleToggle(opt)}
        >
          {opt}
        </button>
      ))}
    </div>
  );
};
export default DashboardToggleComponent;
